import vue from 'vue'

// state
export const state = {
  doorPosition: [],
  doorColor: [],
  doorImage: [],
  doorShow: true
}

// getters
export const getters = {
  doorsCurrent: (state, getters, rootState, rootGetters) => {
    let doorsCollection = rootGetters['doors/doorsCollection']

    if (doorsCollection === undefined && !doorsCollection.length) return []

    return getDoorsCurrent(doorsCollection)
  },

  getColorDoorCurrent: (state, getters) => {
    let doorCurrent = getters.doorsCurrent

    let color = ''

    for (var i = 0; i < doorCurrent.length; i++) {
      if (color !== '' && color !== doorCurrent[i].color) return ''

      color = doorCurrent[i].color
    }

    return color
  },

  doorDescription: (state, getters) => (index) => {
    return getters.doorsCurrent[index].description
  }
}

// mutations
export const mutations = {
  CHANGE_DOOR_SHADOW (state, status) {
    state.moduleShadow = status
  },

  SET_DOOR_POSITION (state, payload) {
    vue.set(state.doorPosition, payload.index, payload.position)
  },

  CLEAR_DOOR_CURRENT (state) {
    state.doorPosition = []
    state.doorColor = []

    state.doorShow = true
  },

  SET_DOOR_IMAGE (state, payload) {
    state.doorImage = payload
  },

  SET_DOOR_SHOW (state, payload) {
    state.doorShow = payload
  }
}

function getDoorsCurrent (doorsCollection) {
  let doorsCurrent = []

  for (var i = 0; i < state.doorPosition.length; i++) {
    doorsCurrent.push(doorsCollection[i][state.doorPosition[i]])
  }

  return doorsCurrent
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/doorCurrent.js